import { z } from 'zod';

const ApiErrorMessageSchema = z.object({ message: z.string() });

export function getMcpApiErrorMessage(body: unknown, fallback: string): string {
  const parsed = ApiErrorMessageSchema.safeParse(body);
  return parsed.success ? parsed.data.message : fallback;
}
